import * as React from 'react';
import { cn } from '@/lib/utils';
import { cva } from 'class-variance-authority';
import { Tooltip as ReactTooltip } from 'react-tooltip';

const GuideLvl = React.forwardRef(({ className, ...props }, ref) => (
  <ul
    ref={ref}
    className={cn('c-guide-lvl', 'flex flex-col gap-12', className)}
    {...props}
  />
));
GuideLvl.displayName = 'GuideLvl';

const GuideLvlItem = React.forwardRef(({ className, ...props }, ref) => (
  <li
    ref={ref}
    className={cn('c-guide-lvl-item', 'flex flex-wrap items-center gap-4', className)}
    {...props}
  />
));
GuideLvlItem.displayName = 'GuideLvlItem';

const GuideLvlTooltip = React.forwardRef(({ className, ...props }, ref) => (
  <ReactTooltip
    ref={ref}
    noArrow
    className={cn('c-guide-lvl-tooltip', 'flex w-[520px] max-w-full flex-wrap items-center gap-4 rounded-lg bg-bright p-5 text-left shadow-[0px_4px_10px_3px_rgba(93,106,134,0.20)]', className)}
    style={{ '--rt-opacity': 1, backgroundColor: '#F2F5FD' }}
    {...props}
  />
));
GuideLvlTooltip.displayName = 'GuideLvlTooltip';

const GuideLvlContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-lvl-content', 'w-[220px] max-w-full grow', className)}
    {...props}
  />
));
GuideLvlContent.displayName = 'GuideLvlContent';

const GuideLvlTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h4
    ref={ref}
    className={cn('c-guide-lvl-title', 'mb-0 text-base font-bold text-primary-dark', className)}
    {...props}
  />
));
GuideLvlTitle.displayName = 'GuideLvlTitle';

const GuideLvlSubtitle = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-guide-lvl-subtitle', 'mb-0 text-sm text-neutral-darker', className)}
    {...props}
  />
));
GuideLvlSubtitle.displayName = 'GuideLvlSubtitle';

const guideLvlTagVariants = cva('c-guide-lvl-tag cursor-help inline-flex items-center gap-2 max-w-full rounded-full py-1 pr-1 pl-[10px]', {
  variants: {
    variant: {
      danger: 'bg-danger',
      third: 'bg-third',
      warning: 'bg-warning',
      success: 'bg-success',
      'success-light': 'bg-success-light',
      'neutral-light': 'bg-neutral-light'
    }
  },
  defaultVariants: {
    variant: 'neutral-light'
  }
});

const GuideLvlTag = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(guideLvlTagVariants({ variant }), className)}
    {...props}
  />
));
GuideLvlTag.displayName = 'GuideLvlTag';

const GuideLvlTagText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-guide-lvl-tag-text', 'truncate text-xs font-bold text-white', 'mb-0 shrink', className)}
    {...props}
  />
));
GuideLvlTagText.displayName = 'GuideLvlTagText';

const GuideLvlTagImgWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <figure
    ref={ref}
    className={cn('c-guide-lvl-tag-img-wrapper', 'h-7 w-7 shrink-0 rounded-full bg-white', 'inline-flex items-center justify-center', className)}
    {...props}
  />
));
GuideLvlTagImgWrapper.displayName = 'GuideLvlTagImgWrapper';

const GuideLvlTagImg = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn('c-guide-lvl-tag-img', 'h-5 w-auto', className)}
    {...props}
  />
));
GuideLvlTagImg.displayName = 'GuideLvlTagImg';

export { GuideLvl, GuideLvlItem, GuideLvlTooltip, GuideLvlContent, GuideLvlTitle, GuideLvlSubtitle, GuideLvlTag, GuideLvlTagText, GuideLvlTagImgWrapper, GuideLvlTagImg };
